import { ENV_DEV } from '../../config';
import { getConfig } from '../../config/config';

export const getGCloudAPIEndpoint = () => {
  const { consoleURL } = getConfig();
  if (ENV_DEV) {
    return `http:${consoleURL}`;
  }
  return window.location.origin;
};
